var _rect, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clv",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 38,
    height: 38,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Player",
    transform: "translate(0 10.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(0.927 15.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4400",
    "data-name": "Path 4400",
    d: "M52.122,266.809H30.3c0-7.572,5.872-9.241,10.91-9.241S52.122,259.237,52.122,266.809Z",
    transform: "translate(-30.302 -257.568)",
    fill: "#b1d28b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4401",
    "data-name": "Path 4401",
    d: "M37.376,252.989H15.556a.911.911,0,0,1-.927-.927c0-6.552,4.2-10.168,11.837-10.168S38.3,245.51,38.3,252.062A.911.911,0,0,1,37.376,252.989Zm-20.862-1.854h19.9c-.371-4.914-3.709-7.387-9.952-7.387S16.885,246.221,16.514,251.135Z",
    transform: "translate(-14.629 -227.584)",
    fill: "#3c4043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4402",
    "data-name": "Path 4402",
    d: "M116.91,12.95a6.433,6.433,0,0,1-6.15-6.676,6.152,6.152,0,1,1,12.3,0A6.433,6.433,0,0,1,116.91,12.95Zm0-11.1a4.206,4.206,0,0,0-4.3,4.42,4.325,4.325,0,1,0,8.592,0A4.259,4.259,0,0,0,116.91,1.854Z",
    transform: "translate(-105.073)",
    fill: "#3c4043"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(8.965 3.346)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 2.895,
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 2.428, 0.425)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 2.895,
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 0.426, 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(22.824 19.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#d4a1dd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Circle-2",
    "data-name": "Circle",
    transform: "translate(1.382 9.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#8bdbf5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Polygon",
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 30.291, 25.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M0,3.641,2.1,0,4.2,3.641Z",
    fill: "none",
    stroke: "#5fb4f6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "diamond_2",
    "data-name": "diamond 2",
    transform: "translate(20.64 2.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4475",
    "data-name": "Path 4475",
    d: "M11.935,19.258H2.855L0,23.151l7.426,9.787L14.79,23.15ZM4.059,23.579l2.092,6.25-4.742-6.25Zm.911,0H9.822l-2.409,7.3Zm5.762,0h2.653L8.658,29.863Zm.765-3.457,1.9,2.593H10.733l-.851-2.593Zm-2.525,0,.851,2.593H4.967l.851-2.593Zm-5.68,0H4.908l-.851,2.593H1.392Z",
    transform: "translate(0 -19.258)",
    fill: "#3c4043"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClv);
export default __webpack_public_path__ + "static/media/clv.c79e4737e29d487a932ae8c13614eb92.svg";
export { ForwardRef as ReactComponent };